import { ReactNode } from "react";
import { OrbitProgress, ThreeDot } from "react-loading-indicators";
import { Card, CardBody, Col, Container, Row } from "reactstrap";

interface MainContentProps {
  children: ReactNode;
  loading?: boolean;
  width?: number;
  saved?: boolean;
  className?: string;
}
export const MainContent = (props: MainContentProps) => {
  if (props.saved) {
    return (
      <div className="spinner-center">
        <ThreeDot variant="pulsate" color="#2563eb" size="medium" text="Saving, please wait..." textColor="" />
      </div>
    );
  }

  if (props.loading) {
    return (
      <div className="spinner-center">
        <OrbitProgress variant="track-disc" color={"#2563eb"} speedPlus={0} easing="linear" />
      </div>
    );
  }
  return (
    <section style={{ backgroundColor: "transparent" }} className={props.className ? props.className : `main-content-secure`}>
      <Container className="py-2 h-100">
        <Row className="d-flex justify-content-center align-items-center h-100">
          <Col className={`col-sm-12 col-md-${props.width ? props.width : 12}`}>
            <Card style={{ borderRadius: "1rem", border: "none", boxShadow: "0 10px 30px -18px rgba(15, 23, 42, 0.35)" }}>
              <Row className="g-0">
                <Col className="">
                  <CardBody className="p-4">{props.children}</CardBody>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
